import { useEffect, useState } from 'react';
// material
import { Button, Container } from '@material-ui/core';
import { Icon } from '@iconify/react';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// eslint-disable-next-line import/no-unresolved
import useSettings from 'src/hooks/useSettings';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
// eslint-disable-next-line import/no-unresolved
import Page from 'src/components/Page';
// eslint-disable-next-line import/no-unresolved
import { PATH_DASHBOARD } from 'src/routes/paths';
import FileCategoryList from './FileCategoryList';
import AddFileCategory from './AddFileCategory';
import { getFileCategoryList } from '../../../../redux/slices/filecategory';
import { getClientList, getProjectListByClient, resetProjectListByClient } from '../../../../redux/slices/client';
// ----------------------------------------------------------------------

export default function FileCategory() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { fileCategoryList, disbaleFileCategoryList, isLoading } = useSelector((state) => state.filecategory);
  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [categoryFileListStatus, setCategoryFileListStatus] = useState(true);
  const [visibleComponent, setVisibleComponent] = useState('List');
  const [currentCategory, setCurrentCategory] = useState({});

  useEffect(() => {
    dispatch(getFileCategoryList(true));
    dispatch(getFileCategoryList(false));
    dispatch(getClientList(true));
    dispatch(resetProjectListByClient());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getFileCategoryList(categoryFileListStatus));
  }, [categoryFileListStatus]);

  useEffect(() => {
    setVisibleComponent('List');
  }, []);

  useEffect(() => {
    if (editId) {
      setVisibleComponent('Edit');
      const tempMasterClient = fileCategoryList.find((client) => client.id === editId);
      const arrayId = tempMasterClient.clients.map((a) => a.id);
      dispatch(getProjectListByClient(arrayId));
      setCurrentCategory(tempMasterClient);
    } else setVisibleComponent('List');
  }, [editId]);

  useEffect(() => {
    if (visibleComponent !== 'Edit') setEditId('');
  }, [visibleComponent]);

  const setComponentList = (e) => {
    setVisibleComponent('List');
    e.preventDefault();
  };

  return (
    <Page title="File Type | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="File Type"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'File Type',
              href: PATH_DASHBOARD.general.master_file,
              handleClick: (e) => {
                setComponentList(e);
              }
            },
            { name: `${visibleComponent} Type` }
          ]}
          action={
            visibleComponent === 'List' ? (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('Create');
                }}
              >
                Add Type
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('List');
                }}
                startIcon={<Icon icon={backFill} />}
              >
                List
              </Button>
            )
          }
        />
        {visibleComponent === 'Create' && <AddFileCategory setVisibleComponent={setVisibleComponent} />}
        {visibleComponent === 'List' && (
          <FileCategoryList
            categoryFileListStatus={categoryFileListStatus}
            setCategoryFileListStatus={setCategoryFileListStatus}
            fileCategoryList={categoryFileListStatus ? fileCategoryList : disbaleFileCategoryList}
            setEditId={setEditId}
            deleteId={deleteId}
            setDeleteId={setDeleteId}
            loading={isLoading}
          />
        )}
        {visibleComponent === 'Edit' && (
          <AddFileCategory
            editId={editId}
            setVisibleComponent={setVisibleComponent}
            currentCategory={currentCategory}
          />
        )}
      </Container>
    </Page>
  );
}
